import { getLocalizedString } from '@grandvisionhq/utils';

const mapBundleChildLineItems = (lineItem, intl)=>{
    if ('configurationItems' in lineItem) {
        return lineItem.configurationDetails.map((child, index)=>toBundleChildLineItem(intl)(child, lineItem.configurationItems[index])
        );
    }
    return lineItem.configurationDetails.map((child)=>toBundleChildLineItem(intl)(child)
    );
};
const toBundleChildLineItem = (intl)=>{
    return (child, configurationItem)=>{
        var ref;
        const lensColor = getLocalizedString(configurationItem === null || configurationItem === void 0 ? void 0 : (ref = configurationItem.product) === null || ref === void 0 ? void 0 : ref.lensColor, intl.locale);
        const body = !!lensColor ? `${getLocalizedString(child.description, intl.locale)} - ${lensColor}` : getLocalizedString(child.description, intl.locale);
        return {
            title: intl.getLabel(`cart.lineItem.glasses.bundleItem.${child.configurationType}`),
            body,
            originalPrice: child.productPrice,
            price: child.totalPaid
        };
    };
};

export { mapBundleChildLineItems, toBundleChildLineItem };
//# sourceMappingURL=map-bundle-child-line-items.js.map
